import {
  FETCH_ALL__ERROR,
  FETCH_ALL__REQUEST,
  FETCH_ALL__SUCCESS,
} from "../../actionTypes";
import { TemplatesActions } from "../../types";

const initialState = false;

const isFetchingAll = (
  state: boolean = initialState,
  action: TemplatesActions
): boolean => {
  switch (action.type) {
    case FETCH_ALL__REQUEST:
      return true;

    case FETCH_ALL__SUCCESS:
    case FETCH_ALL__ERROR:
      return false;

    default:
      return state;
  }
};

export default isFetchingAll;
